import Axios from "../../../../api/axios/Axios";

const BASE_URL = "/api/videos";

export const getVideoPlayback = async (videoTag) => {
  const response = await Axios.get(
    `${BASE_URL}/${encodeURIComponent(videoTag)}/play`,
  );

  return response.data;
};
